import { render, staticRenderFns } from "./ConfirmOrderView.vue?vue&type=template&id=8f78da9c&scoped=true&"
import script from "./ConfirmOrderView.vue?vue&type=script&lang=js&"
export * from "./ConfirmOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f78da9c",
  null
  
)

export default component.exports